import { render, staticRenderFns } from "./ModalViewItems.vue?vue&type=template&id=cdd3d952"
import script from "./ModalViewItems.vue?vue&type=script&lang=js"
export * from "./ModalViewItems.vue?vue&type=script&lang=js"
import style0 from "./ModalViewItems.vue?vue&type=style&index=0&id=cdd3d952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports